module.exports = __webpack_public_path__ + "media/tory_the_sky_guardian.297fcf5e.webm";